// Believemy a été fondé en novembre 2018
const FOUNDING_YEAR = 2018;
const FOUNDING_MONTH = 10; // 0-indexed : 10 = novembre

/**
 * Calcule le nombre d'années écoulées depuis la fondation de Believemy.
 * Bascule pile à chaque anniversaire en novembre (pas le 1er janvier).
 *
 * @returns {number} Nombre d'années entières depuis la fondation
 */
export function computeYearsSinceFounding() {
    const now = new Date();
    let years = now.getFullYear() - FOUNDING_YEAR;
    if (now.getMonth() < FOUNDING_MONTH) years--;
    return Math.max(years, 0);
}
